import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons

import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import { Auth } from "aws-amplify";
import Amplify from "aws-amplify";
import aws_exports from "../../aws-exports";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import CardHeader from "components/Card/CardHeader.jsx";
import cmplogo from "assets/img/cmp-logo.svg";
import CardFooter from "components/Card/CardFooter.jsx";
import API from "@aws-amplify/api";
Amplify.configure(aws_exports);

let apiName = process.env.REACT_APP_AMPLIFY_API;

class SecretPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copiedToCLipboard: "",
      urlCode: "",
      arrayOfClientIds: [],
      cardAnimaton: "cardHidden",
      checked: [],
      secret: "",
      passphrase: "",
      clientId: "",
      passphraseState: "",
      secretState: "",
      errorMsg: "",
      tr: false,
      alertColor: "success"
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.registerClick = this.registerClick.bind(this);
  }
  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        10000
      );
    }
  }

  
  registerClick() {
    if (this.state.passphrase === "") {
      this.setState({ passphraseState: "error" });
    }
    if (this.state.secret === "") {
      this.setState({ secretState: "error" });
    }
  }
  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value
    });
    switch (type) {
      case "passphrase":
          this.setState({ ["passphraseState"]: "success" });
        break;
      case "secret":
          this.setState({ ["secretState"]: "success" });
        break;
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.registerClick();
    if (
      this.state.passphrase !== "" &&
      this.state.secret !== ""
    ) {
      try {
        let p_passphrase = this.state.passphrase;
        let p_secret = this.state.secret;
        let s_path = "/secret";
        let secretParam = {
          body: {
            passphrase: p_passphrase,
            secret: p_secret
          }
        };
        API.put(apiName, s_path, secretParam)
          .then(response => {
            this.setState({urlCode: "https://cmp.io/secret/reveal?id="+response['key']});
          })
          .catch(error => {
            console.log(error.response);
          });
        this.timeOutFunction = setTimeout(
          function() {
            this.setState({ cardAnimaton: "" });
          }.bind(this),
          700
        );
      } catch (e) {
        this.setState({ errorMsg: e["message"] });
        this.setState({ alertColor: "warning" });
        this.showNotification("tr");
      }
    }
  };

  copyUrl(url){
    this.setState({copiedToCLipboard: "copied to clipboard"});
    setTimeout(
      function() {
        this.setState({copiedToCLipboard: ""});
      }.bind(this),
      7000
    );
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = url;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }

  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked
    });
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    /*let path = "/clients";
    API.get(apiName, path)
      .then(response => {
        this.setState({
          arrayOfClientIds: response.map(a => a.id)
        });
      })
      .catch(error => {
        console.log(error.response);
      });*/
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.fullPage}>
        <div className={classes.container}>
          <GridItem xs={12} sm={12} md={3}>
            <Snackbar
              place="tr"
              color={this.state.alertColor}
              message={this.state.errorMsg}
              open={this.state.tr}
              closeNotification={() => this.setState({ tr: false })}
              close
            />
          </GridItem>
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={4}>
              <form className={classes.form} onSubmit={this.handleSubmit}>
               {this.state.urlCode == "" ?
                (<Card login className={classes[this.state.cardAnimaton]}>
                  <CardHeader
                    className={`${classes.cardHeader} ${classes.textCenter}`}
                    color="primary"
                  >
                    <h4 className={classes.cardTitle}>
                     DataDelivers share secure secret
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      success={this.state.secretState === "success"}
                      error={this.state.secretState === "error"}
                      id="secret"
                      labelText="Secret *"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                      }}
                      inputProps={{
                        onChange: event => this.handleChange(event, "secret"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                          </InputAdornment>
                        )
                      }}
                    />

                    <CustomInput
                      success={this.state.passphraseState === "success"}
                      error={this.state.passphraseState === "error"}
                      id="passphrase"
                      labelText="Passphrase *"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                      }}
                      inputProps={{
                        onChange: event => this.handleChange(event, "passphrase"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                          </InputAdornment>
                        )
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.justifyContentCenter}>
                    <Button
                      className="btn btncreate"
                      style={{ padding: "15px 25px" }}
                      color="secondary"
                      // size="lg"
                      type="submit"
                    >
                      SUBMIT
                    </Button>
                  </CardFooter>
                </Card>) :
                (
                  <Card login className={classes[this.state.cardAnimaton]}>
                            <CardHeader
                              className={`${classes.cardHeader} ${classes.textCenter}`}
                              color="primary"
                            >
                              <h4 className={classes.cardTitle}>
                               DataDelivers share secure secret
                              </h4>
                            </CardHeader>
                            <CardBody>
                                  <br/>
                                  <div style={{color: "black", textAlign: "center"}}> <b style={{color: "black", textAlign: "center"}}>{this.state.urlCode}</b></div>
                                  <br/>
                                  <b style={{color: "red", marginLeft:"20%"}}>(note: Link valid for 72 hours.)*</b>
                                  <br/>
                                  <br/>
                                  <br/>
                            </CardBody>
                            <CardFooter className={classes.justifyContentCenter}>
                                <Button
                                  color="secondary"
                                  onClick={() => 
                                    this.copyUrl(
                                        this.state.urlCode
                                    )
                                    }
                                >
                                Copy
                                </Button>
                                <Button
                                  style={{marginLeft: "2%"}}
                                  color="secondary"
                                  onClick={() => 
                                    window.location.href='/secret'
                                    }
                                >
                                Create another 
                                secret
                                </Button>
                                <br/>
                            </CardFooter>
                            <b style={{color: "green", textAlign:"center"}}>{this.state.copiedToCLipboard}</b>
                  </Card>
                )
              }
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

SecretPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(registerPageStyle)(SecretPage);



// WEBPACK FOOTER //
// ./src/views/Pages/Secret.jsx